import { Link } from "react-router-dom";
import type { EventItem } from "@/types/content";
import { formatCount } from "@/utils/format";

type Props = {
  event: EventItem;
  variant?: "default" | "wide";
};

export default function EventCard({ event, variant = "default" }: Props) {
  const isWide = variant === "wide";

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link
        to={`/event/${event.id}`}
        className={`block w-full overflow-hidden ${isWide ? "h-52 sm:h-60" : "h-44"}`}
      >
        <img
          src={event.cover}
          alt={`${event.title} 事件封面图`}
          title={`${event.title} - 热门吃瓜网友热评`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
            {event.categoryName}
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-fire-line text-sm text-primary-500"></i>
            {formatCount(event.heat)}
          </span>
        </div>

        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/event/${event.id}`} className="transition-colors hover:text-primary-600">
            {event.title}
          </Link>
        </h3>

        <p className={`mt-2.5 text-sm leading-relaxed text-foreground-600 ${isWide ? "" : "line-clamp-3"}`}>
          {event.summary}
        </p>

        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line text-sm"></i>
              {formatCount(event.commentCount)} 条评论
            </span>
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-time-line text-sm"></i>
              {event.readTime}
            </span>
          </span>
          <Link
            to={`/event/${event.id}`}
            className="inline-flex items-center gap-0.5 whitespace-nowrap font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            看热评
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}